import React, { useState, useEffect } from 'react';
import {Input, useToaster, Notification, Whisper, IconButton, Tooltip} from 'rsuite';
import {TfiSaveIcon} from "../../../../../../models/Icons.model";
import UpdateButton from "../../../../../shared/UpdateButton/UpdateButton";
import { SharedApi } from "../../../../../../services/Shared.api";

const DimmerPrivateDescriptionSection = ({ deviceId, deviceInfo }) => {
  const [privateDescription, setPrivateDescription] = useState(deviceInfo?.privateDescription || '');
  const [loading, setLoading] = useState(false);
  const toaster = useToaster();

  const message = (
    <Notification type={"success"} closable>
      <p>Данные записаны</p>
    </Notification>
  );

  useEffect(() => {
    if (deviceInfo) {
      setPrivateDescription(deviceInfo.privateDescription || '');
      return;
    }

    loadPrivateDescription().then();
  }, [deviceId, deviceInfo]);

  const loadPrivateDescription = async () => {
    try {
      const data = await SharedApi.getDeviceInfo(String(deviceId));
      setPrivateDescription(data.privateDescription || '');
    } catch (error) {
      console.error('Ошибка загрузки', error);
    }
  };

  const onSavePrivateDescription = async () => {
    try {
      setLoading(true);
      await SharedApi.updatePrivateDescription(String(deviceId), privateDescription);
      toaster.push(message, { placement: "topEnd" });
    } catch (e) {
      console.error('Ошибка сохранения:', e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="w-100">
      <div className="row mb-1">
        <div className="col-12 d-flex justify-content-end gap-2">
          <Whisper placement="top" speaker={<Tooltip>Сохранить</Tooltip>}>
            <IconButton
              style={{marginRight: '10px'}}
              icon={<TfiSaveIcon/>}
              size="sm"
              loading={loading}
              onClick={onSavePrivateDescription}
              className="refresh-btn"
            />
          </Whisper>
          <UpdateButton loading={loading} onRefresh={loadPrivateDescription}/>
        </div>
      </div>
      <div className="row pt-0">
        <div className="col-md-12">
          <Input
            as="textarea"
            rows={4}
            value={privateDescription}
            onChange={(val) => setPrivateDescription(val)}
            onPressEnter={onSavePrivateDescription}
            className="p-2"
            disabled={loading}
          />
        </div>
      </div>
    </section>
  );
};

export default DimmerPrivateDescriptionSection;
